import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { SALES_MODULE_KEY } from '../../settings/constants/roleModules';

export default function SalesInvoiceReadLayout() {
  const title = useRoleModuleLabel(SALES_MODULE_KEY);

  return <EInvoiceAccessLayout permission={READ_SALE_INVOICE} title={title} />;
}
